import {
    TabPanel,
    __experimentalView as View,
    RangeControl,
    TextControl,
    SelectControl,
    Button,
    ButtonGroup,
    __experimentalText as Text,
} from "@wordpress/components";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { desktop, mobile, tablet } from "@wordpress/icons";
import { useSelect } from "@wordpress/data";
import {
    InnerBlocks,
    InspectorControls,
    PanelColorSettings,
    useBlockProps,
    store as blockEditorStore,
} from "@wordpress/block-editor";

const Edit = ({ attributes, setAttributes, clientId }) => {
    const { isBlockSelected } = useSelect(
        (select) => {
            const { getSelectedBlockClientId } = select(blockEditorStore);
            const selectedBlockId = getSelectedBlockClientId();

            return {
                isBlockSelected: selectedBlockId === clientId,
            };
        },
        [clientId]
    );

    const blockProps = useBlockProps({
        className: `modal-block ${isBlockSelected ? `selected` : ``}`,
        style: {
            backgroundColor: `${attributes.overlayBgColor}`,
            backdropFilter: `blur(${attributes.blur}px)`,
            ...(attributes.zIndex.desktop && { "--zIndexDesktop": `${attributes.zIndex.desktop}` }),
            ...(attributes.zIndex.tablet && { "--zIndexTablet": `${attributes.zIndex.tablet}` }),
            ...(attributes.zIndex.mobile && { "--zIndexMobile": `${attributes.zIndex.mobile}` }),
            "--modal-position": `${attributes.position}`,
        },
        "data-trigger": attributes.trigger,
    });
        
    return (
        <Fragment>
            <InspectorControls>
                <TabPanel
                    // className="custom-tab-panel"
                    tabs={[
                        { name: `general`, title: `Ogólne` },
                        { name: `style`, title: `Style` },
                    ]}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        padding: "10px",
                    }}
                >
                    {(tab) => {
                        if (tab.name === `general`) {
                            return (
                                <View style={{ padding: `10px` }}>
                                    <TextControl
                                        __nextHasNoMarginBottom
                                        __next40pxDefaultSize
                                        label="Klasa wywołująca"
                                        value={attributes.trigger}
                                        onChange={(value) => {
                                            setAttributes({
                                                trigger: value,
                                            });
                                        }}
                                    />
                                    <SelectControl
                                        label="Position"
                                        value={attributes.position}
                                        options={[
                                            { label: "Fixed", value: "fixed" },
                                            { label: "Absolute", value: "absolute" },
                                        ]}
                                        onChange={(value) => {
                                            setAttributes({
                                                position: value,
                                            });
                                        }}
                                    />
                                    <TabPanel
                                        className="custom-settings-tab spacing-device-tabs"
                                        activeClass="active-tab"
                                        tabs={[
                                            {
                                                name: "desktop",
                                                title: "Desktop",
                                                icon: desktop,
                                            },
                                            {
                                                name: "tablet",
                                                title: "Tablet",
                                                icon: tablet,
                                            },
                                            {
                                                name: "mobile",
                                                title: "Mobile",
                                                icon: mobile,
                                            },
                                        ]}                                    
                                    >
                                        {(tab) => (
                                            <>
                                                <Text variant="subtitle" as="h3" className="tab-title">
                                                    zIndex
                                                </Text>
                                                
                                                <RangeControl
                                                        // label="Z-index "
                                                        value={attributes.zIndex[tab.name]}
                                                        onChange={(value) => {
                                                            setAttributes({
                                                                zIndex: 
                                                                {
                                                                    ...attributes.zIndex,
                                                                    [tab.name]: value,
                                                                },
                                                            });
                                                        }}
                                                        min={0}
                                                        max={100}
                                                    />
                                            </>
                                        )}
                                        
                                    </TabPanel>
                                    <div className="breakpoint-visibility-controls"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "1rem",
                                    }}>
                                        <p style={{ margin: 0 }}>Ukryj na:</p>
                                        <ButtonGroup>
                                            <Button
                                                icon="desktop"
                                                label="Desktop"
                                                isPressed={attributes.hideBreakpoint.desktop}
                                                onClick={() => {
                                                    setAttributes({
                                                        hideBreakpoint: {
                                                            ...attributes.hideBreakpoint,
                                                            desktop: !attributes.hideBreakpoint.desktop,
                                                        },
                                                    });
                                                }}
                                                title="Toggle visibility on desktop"
                                                style={{ boxShadow: "none" }}
                                            />
                                            <Button
                                                icon="tablet"
                                                label="Tablet"
                                                isPressed={attributes.hideBreakpoint.tablet}
                                                onClick={() => {
                                                    setAttributes({
                                                        hideBreakpoint: {
                                                            ...attributes.hideBreakpoint,
                                                            tablet: !attributes.hideBreakpoint.tablet,
                                                        },
                                                    });
                                                }}
                                                title="Toggle visibility on tablet"
                                                style={{ boxShadow: "none" }}
                                            />
                                            <Button
                                                icon="smartphone"
                                                label="Phone"
                                                isPressed={attributes.hideBreakpoint.phone}
                                                onClick={() => {
                                                    setAttributes({
                                                        hideBreakpoint: {
                                                            ...attributes.hideBreakpoint,
                                                            phone: !attributes.hideBreakpoint.phone,
                                                        },
                                                    });
                                                }}
                                                title="Toggle visibility on phone"
                                                style={{ boxShadow: "none" }}
                                            />
                                        </ButtonGroup>
                                    </div>
                                </View>
                            );
                        } else if (tab.name === "style") {
                            return (
                                <View style={{ padding: `10px` }}>
                                    <PanelColorSettings
                                        title="Ustawienia kolorów"
                                        initialOpen={true}
                                        className="custom-panel-color-settings"
                                        enableAlpha={true}
                                        colorSettings={[
                                            {
                                                value: attributes.overlayBgColor,
                                                onChange: (color) =>
                                                    setAttributes({
                                                        overlayBgColor: color,
                                                    }),
                                                label: "Kolor nakładki",
                                            },
                                        ]}
                                    />
                                    <RangeControl
                                        label="Blur settings"
                                        value={attributes.blur}
                                        onChange={(value) => {
                                            setAttributes({
                                                blur: value,
                                            });
                                        }}
                                        min={0}
                                        max={100}
                                    />
                                </View>
                            );
                        }
                    }}
                </TabPanel>
            </InspectorControls>

            <div {...blockProps}>
                <InnerBlocks
                    template={[
                        ["core/paragraph", { placeholder: "Add blocks…" }],
                    ]}
                    templateLock={false}
                    renderAppender={() => <InnerBlocks.ButtonBlockAppender />}
                />
            </div>
        </Fragment>
    );
};

const Save = ({ attributes }) => {
    const blockProps = useBlockProps.save({
        className: `modal-block ${attributes.position === `absolute` ? `is-modal-card` : ``}
            ${attributes.hideBreakpoint.desktop ? `hide-desktop` : ``}
            ${attributes.hideBreakpoint.tablet ? `hide-tablet` : ``}
            ${attributes.hideBreakpoint.phone ? `hide-phone` : ``}`,
        style: {
            backgroundColor: `${attributes.overlayBgColor}`,
            backdropFilter: `blur(${attributes.blur}px)`,
            ...(attributes.zIndex.desktop && { "--zIndexDesktop": `${attributes.zIndex.desktop}` }),
            ...(attributes.zIndex.tablet && { "--zIndexTablet": `${attributes.zIndex.tablet}` }),
            ...(attributes.zIndex.mobile && { "--zIndexMobile": `${attributes.zIndex.mobile}` }),
            "--modal-position": `${attributes.position}`,
        },
        "data-trigger": attributes.trigger,
    });

    const triggerStyles = `.${attributes.trigger} {cursor: pointer !important;}`

    return (
        <div {...blockProps}>
            <style>{triggerStyles}</style>
            <InnerBlocks.Content />
        </div>
    );
};

registerBlockType(`kamikaze/modal`, {
    apiVersion: 2,
    title: `Modal`,
    icon: `admin-page`,
    category: `layout`,
    supports: {},
    attributes: {
        overlayBgColor: {
            type: `string`,
            default: ``,
        },
        blur: {
            type: `number`,
            default: 10,
        },
        trigger: {
            type: `string`,
            default: ``,
        },
        zIndex: {
            type: `object`,
            default: {
                desktop: 0,
                tablet: 0,
                mobile: 0,
            },
        },
        position: {
            type: `string`,
            default: `fixed`,
        },
        hideBreakpoint: {
            type: `object`,
            default: {
                desktop: false,
                tablet: false,
                phone: false,
            },
        },
    },
    edit: Edit,
    save: Save,
});
